import { Icon, SvgChevronDown, Text } from '@loomhq/lens';
import cn from 'classnames';
import React from 'react';
import AnimateHeight from 'react-animate-height';
import { CSSTransitionGroup } from 'react-transition-group';

import styles from './ChecklistTask.module.less';

const transitionClasses = {
  enter: styles.transitionEnter,
  enterActive: styles.transitionEnterActive,
  leave: styles.transitionLeave,
  leaveActive: styles.transitionLeaveActive,
};

export default function ChecklistTask({
  animated,
  isOpen,
  isComplete,
  isCurrent,
  showCompletionAnimation,
  title,
  children,
  onOpen,
  onClose,
  task,
}) {
  const canOpen = Boolean(children);

  const onClickSummary = event => {
    event.preventDefault();

    if (isOpen) {
      onClose(event);
    } else if (canOpen) {
      onOpen(event);
    }
  };

  const fontWeight = isOpen ? 'black' : 'book';
  const color = isComplete ? 'grey6' : 'grey8';

  return (
    <div
      className={cn(
        styles.details,
        isComplete && styles.isComplete,
        isCurrent && styles.isCurrentTask,
        isOpen && styles.isOpen,
        !canOpen && styles.disabled,
        showCompletionAnimation && styles.completionAnimation
      )}
      open={isOpen}
    >
      <button
        className={styles.summary}
        onClick={onClickSummary}
        tabIndex={canOpen ? '0' : '-1'}
        aria-expanded={isOpen}
      >
        <span className={styles.statusIcon}>
          {animated && (
            <i className={styles.emojiIcon}>{task.completionIcon}</i>
          )}
        </span>
        <CSSTransitionGroup
          transitionName={transitionClasses}
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {animated && (
            <Text fontWeight="black" color="grey8">
              {task.completionMessage}
            </Text>
          )}

          {!animated && (
            <Text fontWeight={fontWeight} color={color}>
              {title}
            </Text>
          )}
        </CSSTransitionGroup>
        {canOpen && (
          <span className={styles.toggleIcon}>
            <Icon
              icon={
                <SvgChevronDown
                  className={styles.toggleIcon}
                  style={{ transform: `rotate(${isOpen ? 180 : 0}deg)` }}
                />
              }
              color={color}
            />
          </span>
        )}
      </button>
      <AnimateHeight
        id={`${task.id}-panel`}
        duration={300}
        height={isOpen ? 'auto' : 0}
      >
        <div className={cn(styles.content, isComplete && styles.isComplete)}>
          {children}
        </div>
      </AnimateHeight>
    </div>
  );
}
